export function refreshIndexes(vm) {
    vm.baseList.map((folder, folderIndex) => {
        folder.index = folderIndex;
        folder.empty = folder.items.length < 1;
        folder.items.map((leverage, leverageIndex) => {
            leverage.in_default_folder = folder.default_folder;
            leverage.index = leverageIndex;
            leverage.folderIndex = folderIndex;
            leverage.folderID = folder.id;
            return leverage;
        });
        return folder;
    });
}
export function createDraggingItemsShell(text) {
    const div = document.createElement('div');
    div.innerText = text;
    return div;
}
export function reducedItems(baseList, visibility, searchField) {
    const result = [];
    let totalItemsIterator = 0;
    const createFolderItem = (folder) => {
        return {
            name: folder.name,
            id: folder.id,
            index: folder.index,
            type: 'folder',
            empty: folder.empty,
            opened: folder.opened,
            haveSelected: folder.haveSelected,
            default_folder: folder.default_folder,
            selected: folder.selected
        };
    };
    for (const folder of baseList) {
        if (!searchField.length) {
            if (folder.items.length) {
                if (folder.opened) {
                    result.push(createFolderItem(folder));
                    totalItemsIterator += 1;
                    result.push(...folder.items.map((item, index, array) => {
                        item.isLastItem = index === array.length - 1;
                        return item;
                    }));
                }
                else {
                    result.push(createFolderItem(folder));
                    totalItemsIterator += 1;
                }
            }
            else {
                if (folder.id > -1) {
                    result.push(createFolderItem(folder));
                    totalItemsIterator += 1;
                }
            }
        }
        else {
            const folderHaveSearchMatchedItems = folder.items.find((item) => {
                return item.name.toLowerCase().indexOf(searchField.toLowerCase()) > -1;
            });
            if (folderHaveSearchMatchedItems) {
                result.push(createFolderItem(folder));
                totalItemsIterator++;
            }
            result.push(...folder.items.filter((item) => {
                return item.name.toLowerCase().indexOf(searchField.toLowerCase()) > -1;
            }).map((item, index, array) => {
                item.isLastItem = index === array.length - 1;
                return item;
            }));
        }
    }
    return result;
}
export function typeBackendAnswer(response) {
    const getMargin = (type) => {
        return type === 'crossed' ? 0 : 1;
    };
    return response.data.map((folder, folderIndex) => {
        folder.haveSelected = false;
        folder.empty = folder.items.length === 0;
        folder.default_folder = folder.defaultFolder;
        delete folder.defaultFolder;
        folder.selected = false;
        folder.items.map((item, itemIndex) => {
            item.marginType = getMargin(item.marginType);
            item.folderIndex = folderIndex;
            item.folderID = folder.id;
            item.selected = false;
            item.isLastItem = itemIndex === folder.items.length - 1;
            item.in_default_folder = item.inDefaultFolder;
            delete item.inDefaultFolder;
            return item;
        });
        return folder;
    });
}
export function setLeveragesStamp(baseList) {
    localStorage.setItem('leveragesStamp', JSON.stringify(baseList));
}
export function getLeveragesStamp() {
    return JSON.parse(localStorage.getItem('leveragesStamp') || '');
}
export function getLeverageFromStampById(baseListStamp, id) {
    for (const folder of baseListStamp) {
        const findedleverageIndex = folder.items.findIndex((leverage) => leverage.id === id);
        if (findedleverageIndex >= 0)
            return folder.items[findedleverageIndex];
    }
}
export var LeveragesErrors;
(function (LeveragesErrors) {
    LeveragesErrors["INVALID_LEVERAGE"] = "INVALID_LEVERAGE";
    LeveragesErrors["THERE_EXISTS_OPEN_ORDERS"] = "THERE_EXISTS_OPEN_ORDERS";
    LeveragesErrors["THERE_EXISTS_QUANTITY"] = "THERE_EXISTS_QUANTITY";
    LeveragesErrors["SYMBOL_ALREADY_CLOSED"] = "SYMBOL_ALREADY_CLOSED";
    LeveragesErrors["ISOLATED_LEVERAGE_REJECT_WITH_POSITION"] = "ISOLATED_LEVERAGE_REJECT_WITH_POSITION";
    LeveragesErrors["JOINT_MARGIN_REJECT_WITH_ISOLATED"] = "JOINT_MARGIN_REJECT_WITH_ISOLATED";
})(LeveragesErrors || (LeveragesErrors = {}));
